import {Component, EventEmitter, Input, Output} from '@angular/core';
import {I18nMessage} from '@app/shared/api/model/i18n';

@Component({
  selector: 'app-ace-file-upload',
  templateUrl: './ace-file-upload.component.html',
  styleUrls: ['./ace-file-upload.component.scss'],
  standalone: false
})
export class AceFileUploadComponent {

  @Input() buttonText: I18nMessage = {messageKey: 'Select file'};
  @Input() clearButtonText: I18nMessage = {messageKey: 'Clear file'};
  @Input() dropText: I18nMessage = {messageKey: 'Or drop file here'};
  @Input() maxFileSize = 14194304;
  @Input() accept = '*';
  @Input() filesUploaded = false;
  @Input() multiple = false;

  @Output() filesChanged = new EventEmitter<File[]>();

  dropValid: boolean;
  dropInvalid: boolean;

  onFilesChange(files: File[] = []) {
    this.filesChanged.emit(files);
    this.filesUploaded = !!files?.length;
  }
}
